import { Inspector } from '@sequencehq/core-components'
import {
  LinkNetsuiteAccountWidget,
  LinkNetsuiteProductWidget,
  LinkRilletProductWidget,
  NetsuiteInspectorItem,
  QuickBooksInspectorItem,
  RilletInspectorItem
} from 'modules/Integrations'
import {
  LinkQuickbooksAccountWidget,
  LinkQuickbooksProductWidget
} from 'Integrations/integrationsConfig/quickBooks/InspectorItem/QuickBooksInspectorItem'

interface Props {
  productId: string
}

export const ProductInspector = ({ productId }: Props) => {
  return (
    <Inspector>
      <Inspector.ItemGroup>
        <QuickBooksInspectorItem>
          <LinkQuickbooksProductWidget productId={productId} />
          <LinkQuickbooksAccountWidget productId={productId} />
        </QuickBooksInspectorItem>
        <RilletInspectorItem>
          <LinkRilletProductWidget productId={productId} />
        </RilletInspectorItem>
        <NetsuiteInspectorItem>
          <LinkNetsuiteProductWidget productId={productId} />
          <LinkNetsuiteAccountWidget productId={productId} />
        </NetsuiteInspectorItem>
      </Inspector.ItemGroup>
    </Inspector>
  )
}
